import script from "./ManagerOrgDeptManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerOrgDeptManagement.vue?vue&type=script&setup=true&lang=js"

import "./ManagerOrgDeptManagement.vue?vue&type=style&index=0&id=2c8d867e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c8d867e"]])

export default __exports__